import React, { useState } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiArrowLeft, FiArrowRight, FiX } = FiIcons;

const Screenshots = () => {
  const [currentImage, setCurrentImage] = useState(null);

  const screenshots = [
    {
      id: 1,
      url: "https://netfills.com/wp-content/uploads/2025/08/crimsonss1.png",
      title: "Guild Raid Victory",
      description: "Our guild celebrating after defeating the legendary Shadow Dragon"
    },
    {
      id: 2,
      url: "https://netfills.com/wp-content/uploads/2025/08/crimsonss2.png",
      title: "Guild Castle",
      description: "Our fortress in the Northern Realms - a place for all guild members to gather"
    },
    {
      id: 3,
      url: "https://netfills.com/wp-content/uploads/2025/08/crimsonss3.png",
      title: "PvP Tournament",
      description: "Annual Crimson Tournament where our best warriors compete for glory"
    }
  ];

  const openLightbox = (index) => {
    setCurrentImage(index);
  };

  const closeLightbox = () => {
    setCurrentImage(null);
  };

  const navigateLightbox = (direction) => {
    const newIndex = (currentImage + direction + screenshots.length) % screenshots.length;
    setCurrentImage(newIndex);
  };

  return (
    <section id="screenshots" className="py-20 relative overflow-hidden">
      {/* Background with gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-blue-900/50 via-purple-900/50 to-red-900/50"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <motion.div 
          className="text-center mb-16"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2 
            className="text-5xl md:text-6xl font-bold mb-6 text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-400" 
            style={{ fontFamily: 'fantasy,serif' }}
          >
            Guild Adventures
          </h2>
          <p className="text-white text-xl max-w-3xl mx-auto leading-relaxed">
            Glimpses from our epic journeys and legendary battles
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {screenshots.map((screenshot, index) => (
            <motion.div
              key={screenshot.id}
              className="group relative overflow-hidden rounded-xl shadow-2xl cursor-pointer"
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.03 }}
              onClick={() => openLightbox(index)}
            >
              {/* Image */}
              <div className="aspect-video overflow-hidden rounded-xl">
                <img 
                  src={screenshot.url} 
                  alt={screenshot.title} 
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
              </div>
              
              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-6 rounded-xl">
                <h3 className="text-2xl font-bold text-white mb-2">{screenshot.title}</h3>
                <p className="text-gray-300">{screenshot.description}</p>
              </div>
              
              {/* Glow effect on hover */}
              <div className="absolute inset-0 border-4 border-transparent group-hover:border-purple-500/50 rounded-xl transition-all duration-300"></div>
            </motion.div>
          ))}
        </div>
        
        {/* Lightbox */}
        {currentImage !== null && (
          <motion.div 
            className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <div className="relative w-full max-w-5xl">
              {/* Close button */}
              <button 
                onClick={closeLightbox}
                className="absolute top-4 right-4 z-10 bg-red-600/80 hover:bg-red-600 text-white rounded-full p-2 transition-colors duration-300"
              >
                <SafeIcon icon={FiX} className="text-xl" />
              </button>
              
              {/* Navigation buttons */}
              <div className="absolute left-4 top-1/2 -translate-y-1/2 z-10">
                <button 
                  onClick={() => navigateLightbox(-1)}
                  className="bg-purple-600/80 hover:bg-purple-600 text-white rounded-full p-3 transition-colors duration-300"
                >
                  <SafeIcon icon={FiArrowLeft} className="text-xl" />
                </button>
              </div>
              <div className="absolute right-4 top-1/2 -translate-y-1/2 z-10">
                <button 
                  onClick={() => navigateLightbox(1)}
                  className="bg-purple-600/80 hover:bg-purple-600 text-white rounded-full p-3 transition-colors duration-300"
                >
                  <SafeIcon icon={FiArrowRight} className="text-xl" />
                </button>
              </div>
              
              {/* Image */}
              <img 
                src={screenshots[currentImage].url} 
                alt={screenshots[currentImage].title}
                className="w-full h-auto max-h-[80vh] object-contain rounded-lg shadow-2xl"
              />
              
              {/* Caption */}
              <div className="bg-gradient-to-r from-purple-900/80 to-blue-900/80 p-4 mt-4 rounded-lg">
                <h3 className="text-xl font-bold text-white">{screenshots[currentImage].title}</h3>
                <p className="text-gray-300">{screenshots[currentImage].description}</p>
              </div>
            </div>
          </motion.div>
        )}
      </div>
    </section>
  );
};

export default Screenshots;